<template>
  <div class="bill-details" ref="container">
    <div class="nav acea-row">
      <div class="item" :class="types == 3 ? 'on' : ''" @click="changeTypes(3)">
        全部
      </div>
      <div class="item" :class="types == 4 ? 'on' : ''" @click="changeTypes(4)">
        今天
      </div>
      <div class="item" :class="types == 5 ? 'on' : ''" @click="changeTypes(5)">
        昨天
      </div>
      <div class="item" :class="types == 6 ? 'on' : ''" @click="changeTypes(6)">
        7天
      </div>
      <div class="item" :class="types == 7 ? 'on' : ''" @click="changeTypes(7)">
        本月
      </div>
      <div class="item" :class="types == 8 ? 'on' : ''" @click="changeTypes(8)">
        上月
      </div>
    </div>

  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name" @click="showPicker">
            <span style="margin-right:0.1rem">
            当前位置：{{cateName}}
            </span>
          </div>
          <div style="font-size:0.3rem;margin-bottom:0.1rem">
            累计供灯数：{{payCount}}
          </div>
          <div style="font-size:0.3rem;margin-bottom:0.1rem">
            累计供灯金额：￥{{totalAmount}}
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in list" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle" style="color:#b37536;font-weight:bold">
            {{order.cateDeviceName}}
          </div>
          <div class="font-color-red" v-if="types==1">
            <span class="sign cart-color acea-row row-center-wrapper">供灯中</span>
          </div>
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯编号】{{ order.orderId }}
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯时间】{{ order.payTime }}
        </div>
        <div class="totalPrice"  style="color:#b37536" v-if="order.lampSelectTime">
          【供灯期限】{{ order.lampSelectTime }}
        </div>
        <div class="totalPrice"  style="color:#b37536" v-if="order.realName">
          【功&nbsp;&nbsp;德&nbsp;&nbsp;主】{{order.realName}}
        </div>
        <div class="totalPrice"  style="color:#b37536">
          【供灯金额】<span class="money font-color-red">￥{{ order.payPrice }}</span>
        </div>
        
        
        
        <div class="totalPrice"  style="color:#b37536" v-if="order.code==1">
          【祈福类型】点亮【平安健康】祈福灯
        </div>
        
        <div class="totalPrice"  style="color:#b37536" v-if="order.code==1">
          【祈&nbsp;&nbsp;福&nbsp;&nbsp;语】{{ order.mark }}
        </div>
        
        <div class="bottom acea-row row-right row-middle">
          <template>
            <div
              class="bnt bg-color-red"
              @click="showOrderInfo(order)">
              祈福详情
            </div>
            <div
              v-if="types==1&&order.lampSelectTime"
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.orderId })">
              立即寻灯
            </div>
          </template>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
    <!-- <Loading :loaded="loaded" :loading="loading"></Loading> -->
     <van-popup v-model="showClassPicker" position="bottom">
        <van-picker
        title="请选择要查看的寺庙"
        show-toolbar
        :columns="columns"
        @confirm="onClassConfirm"
        @cancel="showClassPicker = false"
        />
  </van-popup>
  </div>
  
</template>
<script>
import { getCommissionInfo } from "../../api/user";
import { getOrderData, getOrderList } from "@api/order";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import { getCategoryAll } from "@api/store";
import { Picker } from 'vant'

export default {
  name: "UserBill",
  components: {
    Loading,
    vanPicker: Picker
  },
  props: {},
  data: function() {
    return {
      isMerchant:0,
      columns:[],
      cateName:"",
      cateId:0,
      showClassPicker:false,
      payCount:0,
      totalAmount:0,
      types: "",
      where: {
        page: 1,
        limit: 5
      },
      list: [],
      loaded: false,
      loading: false
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    "$route.params.types": function(newVal) {
      let that = this;
      if (newVal != undefined) {
        that.types = newVal;
        that.list = [];
        that.where.page = 1;
        that.loaded = false;
        that.loading = false;
        that.getIndex();
      }
    },
    types: function() {
      this.getIndex();
    }
  },
  mounted: function() {
    let that = this;
    that.types = that.$route.params.types;
    that.getIndex();
    that.getCategoryAll();
    // that.getUserInfo();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  filters: {
    handleText(value) {
      if (!value) return ''
      if (value.length > 12) {
        return value.slice(0, 100) + '...'
      }
      return value
    }

  },
  methods: {
    // getUserInfo(){
    //       this.$store.dispatch("USERINFO").then((res) => {
    //             this.adminid=res.data.adminid
    //             if(res.data.adminid!='999999'&&res.data.adminid!='0'){
    //                 //普通管理员
    //                 this.adminid=1;
    //             }
    //       });
    // },
    showPicker(){
      if(this.isMerchant==1){
          return ;
      }
      this.showClassPicker = true
    },
    onClassConfirm(v) {
      this.cateName=v.text;
      this.cateId=v.value;
      this.showClassPicker = false;
      this.getIndex();
    },
    getCategoryAll(){
        let that = this;
        getCategoryAll().then(
          res => {
            if(res.data!=null){
                if(res.data.length==1){
                  this.cateName = res.data[0].cateName
                  this.isMerchant=1;//表示是普通管理员
                }else{
                    this.cateName = "请选择寺庙"
                    res.data.forEach((item,index) => { // res.data中有值
                        this.columns.push({
                          text: item.cateName,
                          value:item.id,
                          cardDate:item.cardDate
                        })
                    })
                }
            }
          },
          err => {
            //that.$dialog.message(err.msg);
          }
        );
    },
    showOrderInfo: function(order) {
      //目前只是拿该字段临时来使用
      if(order.code==1){
          order.code=0;
      }else{
         order.code = 1;
      }
    },
    changeTypes: function(val) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      let page=that.where.page
      let limit=that.where.limit
      let type=that.types
      let cateId=that.cateId
      let params={page,limit,type,cateId};
      getOrderList(params).then(res => {
            that.loading = false;
            that.loaded = res.data.storeOrderQueryVo.length < that.where.limit;
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data.storeOrderQueryVo);
            that.payCount=res.data.total
            that.totalAmount=res.data.totalAmount
      });
    },
    


  }
};
</script>
